import { ChangeEvent, useState } from "react";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import UIService from "../../../services/UIService";

type Props = {
    closeModalFn: () => void;
    submitFn: (price: number) => void;
    selectedCount: number;
};

export const BulkManualPriceModal = (props: Props) => {
    const [price, setPrice] = useState<string>("");

    const handleChange = (e: ChangeEvent<any>) => {
        setPrice(e.target.value);
    };

    const handleSubmit = () => {
        const numericPrice = parseFloat(price);
        if (!isNaN(numericPrice)) {
            props.submitFn(numericPrice);
        }
    };

    const isValid = price !== "" && !isNaN(parseFloat(price));

    return (
        <div className={"BulkManualPriceModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle title={"bulk_manual_pricing"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={props.closeModalFn} />
                    </div>
                </div>
            </div>

            <div className={"mt-3"}>
                <OwLabel title={"items_selected"} />
                <span className={"ms-2 fw-bold"}>{props.selectedCount}</span>
            </div>

            <div className={"mt-3"}>
                <OwLabel title={"manual_price"} />
                <OwInputWrapper
                    name={"manualPrice"}
                    type={"number"}
                    value={price}
                    fn={handleChange}
                    onWheelFn={UIService.stopScrollWheel}
                />
            </div>

            <div className={"mt-4 d-flex justify-content-end"}>
                <OwButton title={"save"} fn={handleSubmit} disabled={!isValid} />
                <OwButton title={"cancel"} fn={props.closeModalFn} className={"ms-2 btn-danger"} />
            </div>
        </div>
    );
};
